// extracted by mini-css-extract-plugin
module.exports = {"list":"Navigation_list__cmx1I","logout":"Navigation_logout__3xeiv"};